import { addDays, addMonths } from "date-fns";
import { ChartPieModel } from "model/chart/ChartPieModel";
import Documento from "model/documentos/Documento";
import Pageable from "model/page/Pageable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { useEffect, useState } from "react";
import DocumentoDashboardService from "service/documentos/DocumentoDashboardService";
import { converterData, diasParaVencer } from "utils/convert";
import DocumentoChartPie from "./charts/DocumentoChartPie";
import { dateRangeFilterTemplate, filterApplyTemplate } from "utils/filterUtils";

const documentoDashboardService = new DocumentoDashboardService();
export function DocumentoDashboardPage() {

    const defaultFilters: DataTableFilterMeta = {
        validade: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<Documento[]>([]);
    const [pageable, setPageable] = useState(new Pageable(0, 15, "id", 0));
    const [totalElements, setTotalElements] = useState<number>(0);
    const [filters, setFilters] = useState<any>(defaultFilters);

    const [filtrandoEmAlerta, setFiltrandoEmAlerta] = useState<boolean>(false);
    const [rowsEmAlerta, setRowsEmAlerta] = useState<Documento[]>([]);
    const [pageableEmAlerta, setPageableEmAlerta] = useState(new Pageable(0, 10, "id", 0));
    const [totalElementsEmAlerta, setTotalElementsEmAlerta] = useState<number>(0);

    const [graficoPizzaData, setGraficoPizzaData] = useState<ChartPieModel>({ title: "", pieces: [] });

    useEffect(() => {
        setFiltrando(true);

        documentoDashboardService.pesquisarEmAlerta(pageableEmAlerta).then(data => {
            setRowsEmAlerta(data.content);
            setTotalElementsEmAlerta(data.totalElements);
        }).catch(err => {
            console.error(err);
        });
        documentoDashboardService.graficoPizza().then(data => {
            setGraficoPizzaData(data);
        }).catch(err => {
            console.error(err);
        });
    }, [])

    const onPage = (event: DataTableStateEvent) => {
        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setFiltrando(true);
    };

    useEffect(() => {
        setFiltrando(true);
    }, [filters, pageable]);

    useEffect(() => {
        if (filtrando) {
            documentoDashboardService.pesquisar(pageable, filters).then(data => {
                setRows(data.content);
                setTotalElements(data.totalElements);
                setFiltrando(false);
            }).catch(err => {
                setFiltrando(false);
            });
        }
    }, [filtrando, pageable]);

    return (
        <div style={{ display: "flex", columnGap: 10 }}>
            <div style={{ background: "#FFF", borderRadius: 10, width: "59%", boxSizing: "border-box", padding: 10, height: "97vh", boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.25)' }}>

                <DataTable
                    scrollHeight="87vh"
                    scrollable
                    emptyMessage="Nenhum resultado encontrado"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                    currentPageReportTemplate="{first} - {last} de {totalRecords}"
                    filters={filters}
                    onFilter={(e) => {
                        setFilters(e.filters)
                    }}
                    value={rows} lazy dataKey="id" paginator
                    first={pageable.first} rows={15} totalRecords={totalElements} onPage={onPage}
                    loading={filtrando}
                >
                    <Column field="codigoInterno" header="Código" />
                    <Column field="nome" header="Titulo" />
                    <Column field="versaoVigente.validade" header="Validade" body={(rowData) => rowData.versaoVigente ? converterData(rowData.versaoVigente.validade) : ""}
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="validade"
                        filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
                    <Column header="Vencimento" body={(rowData) => rowData.versaoVigente?.validade ? diasParaVencer(rowData.versaoVigente?.validade) : ""} />
                    <Column style={{ width: 130 }} body={(rowData: Documento) => {
                        let texto = "Vigente";
                        let color = '#284703';
                        if (rowData.versaoVigente?.validade && new Date(rowData.versaoVigente?.validade) < new Date()) {
                            texto = "Vencido";
                            color = '#7B0009';
                        } else if (rowData.versaoVigente?.validade && rowData.alertaVencimento && new Date(rowData.versaoVigente?.validade) <= addDays(new Date(), rowData.diasAlertaVencimento)) {
                            texto = "Em alerta";
                            color = "#CC8F00";
                        }
                        return <div style={{ background: color, color: "#FFF", fontWeight: 700, borderRadius: 20, width: 100, height: 25, textAlign: 'center' }}>
                            {texto}
                        </div>
                    }} />
                </DataTable>
            </div>
            <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
                <div style={{ background: "#FFF", borderRadius: 10, width: "100%", boxSizing: "border-box", padding: 10, height: "48vh", marginBottom: '1vh', boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.25)' }}>
                    <DataTable
                        scrollHeight="39vh"
                        scrollable
                        emptyMessage="Nenhum resultado encontrado"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                        currentPageReportTemplate="{first} - {last} de {totalRecords}"
                        value={rowsEmAlerta} lazy dataKey="id" paginator
                        first={pageableEmAlerta.first} rows={10} totalRecords={totalElementsEmAlerta} onPage={onPage}
                        loading={filtrandoEmAlerta}
                        style={{ fontSize: 12 }}
                    >
                        <Column field="nome" header="Titulo" />
                        <Column field="versaoVigente.validade" header="Validade" body={(rowData) => rowData.versaoVigente ? converterData(rowData.versaoVigente.validade) : ""} />
                        <Column style={{ width: 130 }} body={(rowData: Documento) => {
                            let texto = "Vigente";
                            let color = '#284703';
                            if (rowData.versaoVigente?.validade && new Date(rowData.versaoVigente?.validade) < new Date()) {
                                texto = "Vencido";
                                color = '#7B0009';
                            } else if (rowData.versaoVigente?.validade && rowData.alertaVencimento && new Date(rowData.versaoVigente?.validade) <= addDays(new Date(), rowData.diasAlertaVencimento)) {
                                texto = "Em alerta";
                                color = "#CC8F00";
                            }
                            return <div style={{ background: color, fontWeight: 700, color: "#FFF", borderRadius: 20, width: 100, height: 25, textAlign: 'center', alignContent: "center" }}>
                                {texto}
                            </div>
                        }} />
                    </DataTable>
                </div>
                <div style={{ background: "#FFF", borderRadius: 10, width: "100%", boxSizing: "border-box", padding: 10, height: "48vh", marginBottom: '1vh', boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.25)' }}>
                    <DocumentoChartPie dados={graficoPizzaData} />
                </div>
            </div>
        </div>
    )
}